import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Collapse,
  IconButton,
} from "@mui/material";
import styles from "./styles.module.css";
import CircleLoader from "react-spinners/CircleLoader";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function TabelaDinamicaPermissoesSubMenuRow(props) {
  const { open, row, values, handleChangeCallback } = props;
  
  const [perms, setPerms] = useState([]);
  
  const handleChange = (newPerms) => {
    setPerms(newPerms);

    handleChangeCallback({
      idMenu: row.idMenu,
      menu: row.descricao,
      funcionalidades: newPerms
    });
  }

  useEffect(() => {
    if (values) {
      setPerms(values.funcionalidades);
    }
  }, []);

  return (
    <React.Fragment>
      <TableRow className={styles.tabelaBody}>
        <TableCell sx={{
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
              {row.descricao}
          </Collapse>
        </TableCell>
        <TableCell sx={{
          fontWeight: 'bold',
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Checkbox 
              checked={perms.includes('PODE_INSERIR')} 
              onChange={(e) => {
                (e.target.checked)
                  ? handleChange( [...perms, 'PODE_INSERIR'] )
                  : handleChange( perms.filter(perm => perm !== 'PODE_INSERIR') );
              }} 
            />
          </Collapse>
        </TableCell>
        <TableCell sx={{
          fontWeight: 'bold',
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Checkbox 
              checked={perms.includes('PODE_EDITAR')} 
              onChange={(e) => {
                (e.target.checked)
                  ? handleChange( [...perms, 'PODE_EDITAR'] )
                  : handleChange( perms.filter(perm => perm !== 'PODE_EDITAR') );
              }} 
            />
          </Collapse>
        </TableCell>
        <TableCell sx={{
          fontWeight: 'bold',
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Checkbox 
              checked={perms.includes('PODE_SELECIONAR')} 
              onChange={(e) => {
                (e.target.checked)
                  ? handleChange( [...perms, 'PODE_SELECIONAR'] )
                  : handleChange( perms.filter(perm => perm !== 'PODE_SELECIONAR') );
              }} 
            />
          </Collapse>
        </TableCell>
        <TableCell sx={{
          fontWeight: 'bold',
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Checkbox 
              checked={perms.includes('PODE_EXCLUIR')} 
              onChange={(e) => {
                (e.target.checked)
                  ? handleChange( [...perms, 'PODE_EXCLUIR'] )
                  : handleChange( perms.filter(perm => perm !== 'PODE_EXCLUIR') );
              }} 
            />
          </Collapse>
        </TableCell>
        <TableCell sx={{
          fontWeight: 'bold',
          ...(!open) && {
            paddingBottom: 0, paddingTop: 0, border: "none"
          },
          ...(open) && {
            paddingBottom: 1, paddingTop: 1
          },
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Checkbox checked={
                perms.includes('PODE_INSERIR')
                && perms.includes('PODE_EDITAR')
                && perms.includes('PODE_SELECIONAR')
                && perms.includes('PODE_EXCLUIR')
              } 
              onChange={ (e) => {
                (
                  perms.includes('PODE_INSERIR')
                  && perms.includes('PODE_EDITAR')
                  && perms.includes('PODE_SELECIONAR')
                  && perms.includes('PODE_EXCLUIR')
                )
                  ? handleChange( [] )
                  : handleChange( ['PODE_INSERIR','PODE_EDITAR','PODE_SELECIONAR','PODE_EXCLUIR']);
              }}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

function TabelaDinamicaPermissoesMenuRow (props) {
  const { row, colLength, values, handleChangeCallback } = props;
  const [open, setOpen] = React.useState(false);

  const handleChange = (newSubMenusPerms) => {
    handleChangeCallback(newSubMenusPerms);
  }

  return (
    <React.Fragment>
      <TableRow className={styles.tabelaBody} sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell colSpan={colLength + 1}
          onClick={() => setOpen(!open)} 
          sx={{
            fontWeight: 'bold',
            paddingBottom: 1, 
            paddingTop: 1,
            ":hover": {
              background: "#d4e1ff",
              transition: "all 0.3s ease !important",
            }
          }}>
          {row.menuPai}
          <IconButton
            aria-label="expand row"
            size="small"
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
        
      {row.filhos.length === 0 ? (
        <TableRow className={styles.tabelaBody}>
          <TableCell colSpan={colLength + 1}>
            Nenhum sub-menu encontrado
          </TableCell>
        </TableRow>
      ) : (
        row.filhos.map((submenu) => (
          <TabelaDinamicaPermissoesSubMenuRow
            key={submenu.idMenu} 
            open={open} 
            row={submenu} 
            values={values?.filter(permission => permission.idMenu === submenu.idMenu)[0]} 
            handleChangeCallback={handleChange}
          />
        ))
      )}

    </React.Fragment>
  );

};

function TabelaDinamicaPermissoes(props) {
  const { data, columns, values, loading, handleChangeCallback } = props;

  const handleChange = (newSubMenusPerms) => {
    handleChangeCallback(newSubMenusPerms);
  }

  return (
    <React.Fragment>
      { loading 
        ? (
          <div style={{
            display:"flex",
            paddingTop: "10%",
            paddingLeft: "45%"
          }}>
            <CircleLoader
              color="#18316e"
              loading={loading}
              size={100}
              aria-label="Loading Spinner"
              data-testid="loader"
            /> 
          </div>
        ) :
        <TableContainer className={styles.tabelaGeral}>
          <Table aria-label="dynamic table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell className={styles.tabelaHeader} key={column.id} >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow className={styles.tabelaBody}>
                  <TableCell colSpan={columns.length + 1}>
                    Nenhum registro encontrado
                  </TableCell>
                </TableRow>
              ) : (
                data.map((row) => (
                  <TabelaDinamicaPermissoesMenuRow 
                    key={row.idMenuPai} 
                    row={row} 
                    values={values} 
                    colLength={columns.length} 
                    handleChangeCallback={handleChange}
                  />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </React.Fragment>
  );
};

export default TabelaDinamicaPermissoes;
